"use strict";

(function ($) {

    const LegalUsSearch = {

        documentForm: $('.wpr-all-documents form'),
        keyupTimer: '',
        pagination: $('.wpr_pagination'),
        searchPage: $('body.page-template-search'),
        init: () => {

            if ( LegalUsSearch.searchPage.length ) {
            
                if ( LegalUsSearch.getUrlParameter('l_cat') ) {
    
                    $('.wpr-all-documents .documents ul li.active').removeClass('active');
                    $(".wpr-all-documents .documents ul li a[href=".concat(getUrlParameter('l_cat'), "]")).parent().addClass('active');
    
                }
    
            }

        },
        link: form => {
            $('#wpr-show-all-results a').attr( 'href', "/search/".concat( form.find('input').val() ) );
        },
        getUrlParameter: sParam => {

            let sPageURL = window.location.search.substring(1);
            let sURLVariables = sPageURL.split('&');
            let sParameterName;

            for ( let i = 0; i < sURLVariables.length; i++ ) {
                sParameterName = sURLVariables[i].split('=');
                if ( sParameterName[0] === sParam ) {
                    return sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
                }
            }

            return false;

        },
        onSearchFormSubmit: form => {

            $('html, body').animate({
                scrollTop: $('.wpr-help').offset().top
            }, 1500);
            
            LegalUsSearch.link( form );
            LegalUsSearch.documentForm.find('input').val( form.find('input').val() );
            LegalUsSearch.documentForm.submit();

        },
        onSearchCategoryChange: category => {

            $('.wpr-all-documents ul li.active').removeClass('active');
            category.parent().addClass('active');
            let cat  = category.attr('href');
            let data = {
                action: 'wpr_search',
                cat: cat,
                wpr_search: LegalUsSearch.documentForm.find('input').val(),
                search_page: LegalUsSearch.searchPage.length,
                id: LegalUsSearch.searchPage.find('main > div').data('id')
            };

            LegalUsSearch.doAjax(data, cat);

        },
        onSearchFormSubmit: evt => {

            LegalUsSearch.link( LegalUsSearch.documentForm );

            var data = {
                action: 'wpr_search',
                cat: $('.wpr-all-documents ul li.active a').attr('href'),
                wpr_search: LegalUsSearch.documentForm.find('input').val(),
                page: 1,
                search_page: LegalUsSearch.searchPage.length,
                id: LegalUsSearch.searchPage.find('main > div').data('id')
            };

            if ('keyup' === evt.type) {
                
                clearTimeout(LegalUsSearch.keyupTimer);
                LegalUsSearch.keyupTimer = setTimeout(function () {
                    LegalUsSearch.doAjax(data);
                }, 1000);

            } else {
                LegalUsSearch.doAjax(data);
            }

        },
        doAjax: data => {

            let cat = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

            $.ajax({
                type: 'GET',
                url: WPRAjax.ajax_url,
                data: data,
                dataType: 'json',
                // xml, html, script, json, jsonp, text
                success: function success(data) {
                    LegalUsSearch.ajaxResponse(data, cat);
                },
                error: function (_error) {

                    function error(_x, _x2, _x3) {
                        return _error.apply(this, arguments);
                    }
                    error.toString = function () {
                        return _error.toString();
                    };
                    
                    return error;

                }( function (jqXHR, textStatus, errorThrown ) {
                    error.log(errorThrown);
                }),
                // called when the request finishes (after success and error callbacks are executed)
                complete: function complete(jqXHR, textStatus) {
                    // console.log(textStatus);
                }
            });

        },
        ajaxResponse: (response) => {

            let cat = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
            
            let searchContainer = $('.wpr-all-documents .search');
            searchContainer.empty();
            searchContainer.parent().find('.wpr-no-results').remove();

            if (response.documents && response.documents.length) {
                let sup = $('.wpr-all-documents ul li a span sup');
                sup.empty();
                sup.append("[".concat(response.total, "]"));

                let html = '';
                for ( let i = 0; i < response.documents.length; i++ ) {
                    
                    html = "<a href=\"".concat(response.documents[i].guid, "\"\nclass=\"wpr-content rounded-[15px] !text-white bg-white border border-brd px-5 py-[50px] relative cursor-pointer drop-shadow-doc\">\n<div class=\"search-document-title capitalize text-black\">\n").concat(response.documents[i].title, "\n</div>\n<p class=\"text-gray font-normal text-xs leading-[18px] sm:text-base\">\n").concat(response.documents[i].excerpt, "\n</p>\n").concat(response.svgs.arrow, "\n</a>");

                    searchContainer.append(html);

                }

            } else {
                
                searchContainer.parent().find('form').append(response['no_documents']);

            }

            LegalUsSearch.pagination.empty();
            LegalUsSearch.pagination.append(response.pagination);

            let paginationLink = LegalUsSearch.pagination.find('a');
            let s = LegalUsSearch.documentForm.find('input').val() ? "".concat(LegalUsSearch.documentForm.find('input').val()) : '';
            let c = '#' !== cat && cat ? "&l_cat=".concat(cat) : '';
            
            paginationLink.each(function () {
                $(this).attr('href', window.location.origin + "/search/".concat(s, "?l_page=").concat($(this).text()).concat(c));
            });

        }

    }

    $(document).ready(function () {

        LegalUsSearch.init();

        $('form.wpr-search-form').submit(function (e) {
            e.preventDefault();
            LegalUsSearch.onSearchFormSubmit( jQuery(this) );
        });

        $('.wpr-all-documents ul:not(.page-numbers) li a').on('click', function(evt) {
            evt.preventDefault();
            LegalUsSearch.onSearchCategoryChange( jQuery(this) );    
        });

        LegalUsSearch.documentForm.on('submit keyup', function (evt) {
            evt.preventDefault();
            LegalUsSearch.onSearchFormSubmit( evt );    
        });

    });

})(jQuery);